/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import Label from "components/Label";
import React, { FC, useEffect, ElementType } from "react";
import { isEmpty } from "utils/array";

import styles from "./styles.module.scss";

type Option = {
  value: string;
  label: string;
  Icon: ElementType;
};

type Props = {
  onChange: (newValue: string[] | undefined) => void;
  initialValue?: string[];
  value: string[] | undefined;
  options: Option[];
};

const IconSelect: FC<Props> = ({ onChange, initialValue, value, options }) => {
  useEffect(() => {
    if (initialValue) onChange(initialValue);
  }, []);

  return (
    <div className={styles.container}>
      {options.map(({ value: optionValue, label, Icon }) => {
        const selected = value?.includes(optionValue);

        return (
          <div
            onClick={() => {
              if (selected) {
                const newValues = value?.filter(
                  (selectedValue) => selectedValue !== optionValue
                );

                if (newValues && isEmpty(newValues)) onChange(undefined);
                else onChange(newValues);
              } else if (value && !isEmpty(value))
                onChange([...value, optionValue]);
              else onChange([optionValue]);
            }}
            className={styles.item}
          >
            <div
              className={`${styles.iconWrapper} ${selected && styles.selected}`}
            >
              <Icon />
            </div>
            <Label
              className={styles.label}
              variant="centered-body"
              color="primary2"
            >
              {label}
            </Label>
          </div>
        );
      })}
    </div>
  );
};

IconSelect.defaultProps = {
  initialValue: undefined
};

export default IconSelect;
